var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.150329 5.88095L4.77571 10.5048C4.97866 10.7072 5.30749 10.7072 5.51096 10.5048C5.71392 10.3023 5.71392 9.97352 5.51096 9.77108L1.25246 5.51412L5.51045 1.25716C5.71341 1.05471 5.71341 0.725887 5.51045 0.522928C5.30749 0.320482 4.97815 0.320482 4.77519 0.522928L0.149816 5.14672C-0.0500242 5.34708 -0.0500241 5.68107 0.150329 5.88095Z",
    fill: "#BBC2D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.bce63afc1233c88b0fbf3440b4733308.svg";
export { ForwardRef as ReactComponent };